module.exports = __webpack_public_path__ + "img/google-play-logo.36cc932d.svg";